import React, { useState, useEffect } from 'react';
import { X, RefreshCw, ImageOff } from 'lucide-react';
import Layout from '../components/layout/Layout';
import LazyImage from '../components/ui/LazyImage';

const API_URL = process.env.REACT_APP_BACKEND_URL;

const GalleryPage = () => {
  const [selectedImage, setSelectedImage] = useState(null);
  const [galleryItems, setGalleryItems] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    fetchGallery();
  }, []);

  const fetchGallery = async () => {
    try {
      setLoading(true);
      setError(null);
      const response = await fetch(`${API_URL}/api/gallery`);
      if (response.ok) {
        const data = await response.json();
        setGalleryItems(data);
      } else {
        setError('Ошибка загрузки галереи');
      }
    } catch (err) {
      console.error('Error fetching gallery:', err);
      setError('Ошибка подключения к серверу');
    } finally {
      setLoading(false);
    }
  };

  if (loading) {
    return (
      <Layout>
        <div className="container mx-auto px-4 py-16 text-center">
          <RefreshCw className="w-8 h-8 animate-spin mx-auto text-emerald-600 mb-4" />
          <p className="text-gray-500">Загрузка галереи...</p>
        </div>
      </Layout>
    );
  }

  return (
    <Layout>
      <div className="bg-gradient-to-br from-emerald-50 to-green-50 py-10">
        <div className="container mx-auto px-4">
          <h1 className="text-3xl md:text-4xl font-bold text-gray-900 mb-2">Галерея работ</h1>
          <p className="text-gray-600">Фотографии установленных нами теплиц</p>
        </div>
      </div>

      <div className="container mx-auto px-4 py-12">
        {error ? (
          <div className="text-center py-12">
            <ImageOff className="w-12 h-12 mx-auto text-gray-400 mb-4" />
            <p className="text-gray-600">{error}</p>
          </div>
        ) : galleryItems.length === 0 ? (
          <div className="text-center py-12">
            <ImageOff className="w-12 h-12 mx-auto text-gray-400 mb-4" />
            <p className="text-gray-600">Галерея пока пуста</p>
          </div>
        ) : (
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
            {galleryItems.map((item) => (
              <div
                key={item.id}
                onClick={() => setSelectedImage(item)}
                className="group cursor-pointer"
              >
                <div className="aspect-[4/3] rounded-2xl overflow-hidden bg-gray-100 mb-3">
                  <LazyImage
                    src={item.image}
                    alt={item.title}
                    className="w-full h-full group-hover:scale-105 transition-transform duration-500"
                  />
                </div>
                <h3 className="font-semibold text-gray-900 group-hover:text-emerald-600 transition-colors">
                  {item.title}
                </h3>
                <p className="text-sm text-gray-500">{item.location}</p>
                <p className="text-sm text-emerald-600">{item.date}</p>
              </div>
            ))}
          </div>
        )}
      </div>

      {selectedImage && (
        <div 
          className="fixed inset-0 z-50 bg-black/90 flex items-center justify-center p-4"
          onClick={() => setSelectedImage(null)}
        >
          <button 
            className="absolute top-4 right-4 text-white hover:text-gray-300 transition-colors"
            onClick={() => setSelectedImage(null)}
          >
            <X className="w-8 h-8" />
          </button>
          <div className="max-w-4xl w-full" onClick={e => e.stopPropagation()}>
            <img
              src={selectedImage.image}
              alt={selectedImage.title}
              className="w-full rounded-lg"
            />
            <div className="mt-4 text-white">
              <h3 className="text-xl font-semibold">{selectedImage.title}</h3>
              <p className="text-gray-300">{selectedImage.location} • {selectedImage.date}</p>
            </div>
          </div>
        </div>
      )}
    </Layout>
  );
};

export default GalleryPage;
